import { motion } from 'framer-motion'
import React from 'react'
import { pageVariants } from './Home'

const NotFound = () => {

  return(
    <motion.main initial="initial"
    animate="animate"
    exit='exit'
    variants={pageVariants}
    >
    <section className="notfound">
      <h1>Error 404 Not found</h1>
    </section>

    </motion.main>
  )
}

export default NotFound